import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import type { SharedInspectionFinding } from "../api/dto/SharedInspectionFinding";
import { ModalFooter } from "../components/layout/ModalProvider";
import { Paragraph } from "../components/Paragraph";

export const RevokeSharedInspectionFindingModal: FC<{
  inspection: Inspection;
  sharedInspectionFinding: SharedInspectionFinding;
  onFinish?: () => void;
}> = (props) => {
  const { revokeSharedInspectionFinding } = useApiCall();
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    try {
      await revokeSharedInspectionFinding(props.inspection.id, props.sharedInspectionFinding.uuid);
      props.onFinish?.();
    } catch (e) {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
        return;
      }
      throw e;
    }
  };

  return (
    <>
      <Paragraph>
        <div>Weet je zeker dat je deze link wilt terugtrekken?</div>
      </Paragraph>
      <ModalFooter text={"Verwijderen"} icon={faTimes} onSubmit={save} />
    </>
  );
};
